/**
 * Constant function - takes a value and returns a function that always returns that value
 * @param value - The constant value to return
 * @returns A function that always returns the provided value
 */
export const Constant =
  <T>(value: T): (() => T) =>
  () =>
    value
